import SlotGroup from "./SlotGroup";
import {SlotGroupInterface} from "@/types";

export default class SlotGroupController {
  private squadNames: string[] = [
    "Command",
    "Alpha",
    "Bravo",
    "Charlie",
    "Delta",
    "Echo",
    "Foxtrot",
    "Golf",
    "Hotel",
    "India",
    "Juliet",
    "Kilo",
    "Lima",
    "Mike",
    "November",
    "Oscar",
    "Papa",
    "Quebec",
    "Romeo",
    "Sierra",
    "Tango",
    "Uniform",
    "Victor",
    "Whiskey",
    "X-Ray",
    "Yankee",
    "Zulu"
  ];

  public createSlotGroup (): SlotGroup {
    const squadName = this.generateName();
    return new SlotGroup(squadName);
  }

  public copySlotGroup (slotGroup: SlotGroup): SlotGroup {
    const squadName = this.generateName();
    return new SlotGroup(squadName, slotGroup.description, slotGroup.playerSlots);
  }

  public generateName (): string {
    return this.squadNames.shift()!;
  }

  public renameSlotGroup (slotGroup: SlotGroup, newName: string) {
    if (slotGroup.hasDefaultName) {
      this.addSquadName(slotGroup.name);
      slotGroup.hasDefaultName = false;
    }

    if (this.squadNames.includes(newName)) {
      this.removeSquadName(newName);
      slotGroup.hasDefaultName = true;
    }

    slotGroup.name = newName;
  }

  public removeSlotGroup (index: number, slotGroups: SlotGroup[]) {
    const slotGroup = slotGroups[index];
    this.addSquadName(slotGroup.name);
    slotGroups.splice(index, 1);
  }

  private removeSquadName (newName: string) {
    const index = this.squadNames.findIndex((name) => name === newName);
    this.squadNames.splice(index, 1);
  }

  private addSquadName (name: string) {
    this.squadNames.push(name);
    this.squadNames.sort();
  }
}
